const FIELD_LABEL_MAPPING = {
  iLineShipments: 'iLine Shipments',
  destinationBills: 'Destination bills',
  returns: 'Returns',
  priorityBills: 'Priority Bills',
  dockPickups: 'Dock Pickups',
  appts: 'APPTs',
  billsEnrouteToDestination: 'Bills enroute to the destination',
  shipmentsRequireGeocoding: 'Shipments require geocoding'
};

const BUTTON_LABELS = {
  CREATE_ROUTES: 'Create Routes',
  VIEW_PLAN: 'View Plan'
};

export { FIELD_LABEL_MAPPING, BUTTON_LABELS };